<script context="module">

    import { client, gql } from "./GraphQL.svelte";

    const ALL_IDS_QUERY = gql`
        query {
            companies { id }
        }
    `;

    export function allIds() {
        return client.query({
            query: ALL_IDS_QUERY
        });
    }

    const ALL_COMPANIES_QUERY = gql`
        query {
            companies { id, name }
        }
    `;

    export function all() {
        return client.query({
            query: ALL_COMPANIES_QUERY
        });
    }

    const CREATE_COMPANY_MUTATION = gql`
        mutation($company: AddCompanyInput!) {
            addCompany(company: $company) {
                id, creationTime
        }}
    `;

    const DELETE_COMPANY_MUTATION = gql`
        mutation($id: Guid!) {
            deleteCompany(id: $id) {
                id, creationTime
        }}
    `;

    export function createCompany({name, websiteUrl, eyeventureUrl}) {
        return client.mutate({
            mutation: CREATE_COMPANY_MUTATION,
            variables: {
                company: {name, websiteUrl, eyeventureUrl}
            }
        });
    }

    export function deleteCompany(id) {
        return client.mutate({
            mutation: DELETE_COMPANY_MUTATION,
            variables: {
                id
            }
        });
    }

    export function deleteByModel(model) {
        return deleteCompany(model.id);
    }

    // TODO: wrap in batch Promise
    export function deleteByIds(ids) {
        (ids || []).forEach(deleteCompany);
    }

    // TODO: wrap in batch Promise
    export function deleteByModels(models) {
        (models || []).forEach(deleteByModel);
    }

    // TODO: wrap in batch Promise
    export function deleteAll() {
        return allIds().then(res => {
            res.data.companies.forEach(deleteByModel);
        })
    }


</script>